import { useEffect } from "react";
import type { ErrorComponentProps } from "@tanstack/react-router";
import Link from "@/components/link";

// A page that threw (a source down, a query that failed) lands here instead of
// a blank page: the shell stays, with a retry and a way home. The router's
// default error component (main.tsx), so every page route gets it.

export function ReportError({ error, reset }: ErrorComponentProps) {
  useEffect(() => {
    console.error("page failed", error);
  }, [error]);

  return (
    <div className="page-shell-narrow">
      <div className="rounded-xl border border-border bg-surface p-6">
        <p className="font-heading text-[11px] font-semibold uppercase tracking-widest text-muted">Something went wrong</p>
        <h1 className="mt-2 font-heading text-xl font-bold text-foreground">This page could not load</h1>
        <p className="mt-2 text-sm text-muted">
          One of the sources behind this page did not answer. Try again in a moment; if it keeps happening, tell Digital King.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={reset}
            className="rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-hover"
          >
            Try again
          </button>
          <Link href="/" className="rounded-lg border border-border px-3 py-2 text-sm font-semibold text-foreground transition-colors hover:bg-surface-2">
            Back to the dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
